import {
    Component,
    EventEmitter,
    TemplateRef,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'pm-line-bar-chart',
    //templateUrl: './app/controls/components/chart/line-bar-chart/line-bar-chart.html'
    templateUrl: './line-bar-chart.html',
})
export class LineBarChartComponent {

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/line-bar-chart/line-bar-chart-component.ts